import PortalVue from 'portal-vue';
import Vue from '../../node_modules/vue';

Vue.use(PortalVue);
